import React from "react";
import {Modal, Typography} from "antd";

import {
    SubCompaniesModalCell,
    SubCompaniesModalGrid,
    SubCompaniesModalIndex,
    SubCompaniesModalName,
    subCompaniesModalBodyStyle
} from "../styles/PoolIntensity.styled";

const {Text} = Typography;

/** API'den gelen alt firma metnini okunabilir satırlara böler (virgül, noktalı virgül, pipe, satır sonu). */
export const parseSubCompanyNames = raw => {
    if (raw == null) return [];
    const str = typeof raw === "string" ? raw.trim() : String(raw).trim();
    if (!str) return [];

    const split = str
        .split(/\s*[,;|]\s*|\n+/)
        .map(s => s.trim())
        .filter(Boolean);

    return split.length ? split : [str];
};

const SubCompaniesDetailModal = ({visible, onCancel, subCompanyName}) => {
    const items = parseSubCompanyNames(subCompanyName);

    return (
        <Modal
            title="🏪 Alt Firmalar"
            visible={visible}
            onCancel={onCancel}
            footer={null}
            centered
            width={720}
            destroyOnClose
            bodyStyle={subCompaniesModalBodyStyle}
        >
            {items.length === 0 ? (
                <Text type="secondary">Kayıt bulunamadı.</Text>
            ) : (
                <SubCompaniesModalGrid>
                    {items.map((name, index) => (
                        <SubCompaniesModalCell key={`${index}-${name}`}>
                            <SubCompaniesModalIndex>{index + 1}.</SubCompaniesModalIndex>
                            <SubCompaniesModalName>{name}</SubCompaniesModalName>
                        </SubCompaniesModalCell>
                    ))}
                </SubCompaniesModalGrid>
            )}
        </Modal>
    );
};

export default SubCompaniesDetailModal;
